export default __webpack_public_path__ + "static/media/taskdriver.7dff1752.svg";